import { computed } from 'vue'
import { DateTime } from 'luxon'
import { priceFmt } from './utils'

export function useOccasion(occasion) {
  const description = computed(() => {
    return occasion.value && occasion.value.description
      ? occasion.value.description
      : occasion.value &&
          occasion.value.product_variant &&
          occasion.value.product_variant.description
        ? occasion.value.product_variant.description
        : occasion.value &&
            occasion.value.product_variant &&
            occasion.value.product_variant.product &&
            occasion.value.product_variant.product.description
          ? occasion.value.product_variant.product.description
          : undefined
  })

  const floorPriceStr = computed(() => {
    return !occasion.value ? '' : priceFmt(occasion.value.floor_price_usd)
  })

  const image = computed(() => {
    return occasion.value &&
      occasion.value.product_variant &&
      occasion.value.product_variant.list_image
      ? occasion.value.product_variant.list_image
      : occasion.value &&
          occasion.value.product_variant &&
          occasion.value.product_variant.person &&
          occasion.value.product_variant.person.list_image
        ? occasion.value.product_variant.person.list_image
        : occasion.value &&
            occasion.value.product_variant &&
            occasion.value.product_variant.product &&
            occasion.value.product_variant.product.list_image
          ? occasion.value.product_variant.product.list_image
          : undefined
  })

  const listPriceStr = computed(() => {
    return !occasion.value ? '' : priceFmt(occasion.value.list_price_usd)
  })

  const name = computed(() => {
    return occasion.value && occasion.value.name
      ? occasion.value.name
      : occasion.value &&
          occasion.value.product_variant &&
          occasion.value.product_variant.name
        ? occasion.value.product_variant.name
        : occasion.value &&
            occasion.value.product_variant.product &&
            occasion.value.product_variant.product.name
          ? occasion.value.product_variant.product.name
          : undefined
  })

  const startDateTime = computed(() => {
    return (
      occasion.value &&
      occasion.value.starts_at &&
      DateTime.fromISO(occasion.value.starts_at, {
        zone: occasion.value.timezone
      }).toLocal()
    )
  })
  const startDateStr = computed(() => {
    return (
      startDateTime.value &&
      startDateTime.value.toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY)
    )
  })
  const endDateTime = computed(() => {
    return (
      occasion.value &&
      occasion.value.ends_at &&
      DateTime.fromISO(occasion.value.ends_at, {
        zone: occasion.value.timezone
      }).toLocal()
    )
  })
  const endDateStr = computed(() => {
    return (
      endDateTime.value &&
      endDateTime.value.toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY)
    )
  })
  const timeStr = computed(() => {
    let str = ''

    if (startDateTime.value && endDateTime.value) {
      const startTime = startDateTime.value.toLocaleString(DateTime.TIME_SIMPLE)
      const endTime = endDateTime.value.toLocaleString(DateTime.TIME_SIMPLE)

      str = `${startTime} – ${endTime} (${endDateTime.value.offsetNameShort})`
    }

    return str
  })

  function scheduleTimeStr(item) {
    let str = ''

    if (occasion.value && item && item.date_time && item.hours) {
      const start = DateTime.fromISO(item.date_time, {
        zone: occasion.value.timezone
      }).toLocal()

      str = `${start.toLocaleString(
        DateTime.DATE_MED_WITH_WEEKDAY
      )} | ${start.toLocaleString(DateTime.TIME_SIMPLE)} - ${start
        .plus({ hours: item.hours })
        .toLocaleString(DateTime.TIME_SIMPLE)} (${
        endDateTime.value.offsetNameShort
      })`
    }

    return str
  }

  return {
    description,
    floorPriceStr,
    image,
    listPriceStr,
    name,
    startDateStr,
    startDateTime,
    endDateStr,
    endDateTime,
    scheduleTimeStr,
    timeStr
  }
}
